import { api } from './api-client';
import { renderLoginPage } from './auth/login-page';
import { renderControlCentre } from './pages/control-centre';
import { renderHomePage } from './pages/home-page';
import { renderSettings } from './pages/settings';
import { renderTransactionDetail } from './pages/transaction-detail';
import { renderDashboard } from './pages/dashboard';
import { renderSpendCheckIn } from './pages/spend-check-in';
import { renderWeeklyReview } from './pages/weekly-review';
import { renderReports } from './pages/reports';
import { renderSmsInbox } from './pages/sms-inbox';
import { renderStatements } from './pages/statements';
import { route, resetRoutes, startRouter, dispatch } from './router';

async function bootstrap() {
  const root = document.getElementById('app')!;
  try {
    const { user } = await api<{ user: { id: string; displayName: string } | null }>('/api/me');
    if (!user) {
      renderLoginPage(root, () => bootstrap());
      return;
    }

    // Register signed-in routes. Control Centre is the landing screen. Reset
    // first so a re-bootstrap (login → success) doesn't duplicate registrations.
    resetRoutes();
    route('/', () => { renderControlCentre(root); });
    route('/control-centre', () => { renderControlCentre(root); });
    route('/log', () => { renderHomePage(root, user); });
    route('/settings', () => renderSettings(root));
    route('/transactions/:id', ({ id }) => renderTransactionDetail(id));
    route('/dashboard', () => renderDashboard(root));
    route('/check-in', () => renderSpendCheckIn(root));
    route('/review', () => renderWeeklyReview(root));
    route('/reports', () => renderReports(root));
    route('/sms-inbox', () => { void renderSmsInbox(root); });
    route('/statements', () => { void renderStatements(root); });

    startRouter();
    await dispatch();
  } catch {
    renderLoginPage(root, () => bootstrap());
  }
}

bootstrap();
